import { Link } from 'react-router-dom';
import { quickDownloads } from '@/mocks/home';
import { useState } from 'react';

function ResourceDownload() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 3000);
    setEmail('');
  };

  return (
    <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-primary-900">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
          <div className="flex-1">
            <span className="inline-block px-4 py-1.5 mb-4 text-xs font-medium text-primary-200 bg-primary-800/50 rounded-full">
              资源下载
            </span>
            <h2 className="text-2xl md:text-4xl font-bold text-white mb-3">
              快捷资源下载区
            </h2>
            <p className="text-sm md:text-base text-white/60 mb-8 max-w-md">
              全系列产品白皮书、安装包、说明书一站下载
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {quickDownloads.map((item) => (
                <a
                  key={item.id}
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 p-3.5 bg-white/5 border border-white/10 rounded-xl hover:bg-white/10 hover:border-white/20 transition-all cursor-pointer"
                >
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500/20 text-primary-300 flex-shrink-0">
                    <i className={`${item.icon} text-base`}></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-medium text-white truncate">{item.title}</div>
                    <div className="text-xs text-white/40">{item.size}</div>
                  </div>
                  <i className="ri-download-2-line text-white/50"></i>
                </a>
              ))}
            </div>
            <Link
              to="/support/downloads"
              className="inline-flex items-center gap-2 mt-6 text-sm font-medium text-primary-300 hover:text-white transition-colors cursor-pointer"
            >
              进入资源下载中心
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ResourceDownload;